import { render } from "./SearchResultProduct.vue?vue&type=template&id=0671f460&scoped=true"
import script from "./SearchResultProduct.vue?vue&type=script&lang=js"
export * from "./SearchResultProduct.vue?vue&type=script&lang=js"

import "./SearchResultProduct.vue?vue&type=style&index=0&id=0671f460&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0671f460"]])

export default __exports__